import { Reveal, SectionHeading } from "./Reveal";
import { useSite } from "@/lib/site";

const NUMERALS = {
  ar: ["١", "٢", "٣"],
  fr: ["1", "2", "3"],
};

export default function HowItWorks({ content }) {
  const { lang } = useSite();
  const c = content?.steps;
  const nums = NUMERALS[lang] || NUMERALS.ar;
  return (
    <section id="steps" className="bg-cream py-24 sm:py-28">
      <div className="mx-auto max-w-7xl px-5">
        <SectionHeading eyebrow={c?.eyebrow} title={c?.title} />
        <div className="relative mt-14 grid gap-10 md:grid-cols-3 md:gap-6">
          <div
            className="absolute top-16 right-[16%] left-[16%] hidden border-t-2 border-dashed border-gold/40 md:block"
            aria-hidden="true"
          />
          {(c?.items || []).map((step, i) => (
            <Reveal key={i} delay={0.12 * i} className="relative">
              <article
                data-testid={`step-card-${i}`}
                className="relative h-full rounded-3xl border border-line bg-white p-8 text-center transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_24px_50px_-24px_rgba(15,56,44,0.35)]"
              >
                <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-forest-900 font-head text-3xl font-black text-gold shadow-lg">
                  {nums[i] || i + 1}
                </span>
                <h3 className="mt-6 font-head text-xl font-bold text-forest-950">{step.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-moss">{step.desc}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
